export interface ApiErrorDetails {
  message: string;
  code?: string;
  retryable: boolean;
  status?: number;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;
}

export function getApiErrorDetails(error: unknown, fallback: string): ApiErrorDetails {
  const root = asRecord(error);
  const response = asRecord(root?.response);
  const data = asRecord(response?.data);
  const remote = data?.error;
  const remoteRecord = asRecord(remote);
  const code = typeof remoteRecord?.code === 'string'
    ? remoteRecord.code
    : (typeof remote === 'string' ? remote : undefined);
  const message = typeof remoteRecord?.message === 'string'
    ? remoteRecord.message
    : (typeof data?.detail === 'string'
      ? data.detail
      : (typeof remote === 'string'
        ? remote
        : (typeof root?.message === 'string' ? root.message : fallback)));
  const status = typeof response?.status === 'number' && Number.isInteger(response.status)
    ? response.status
    : undefined;

  return {
    message: message || fallback,
    code,
    retryable: data?.retryable === true,
    status,
  };
}

export async function getResponseErrorMessage(response: Response, fallback: string): Promise<string> {
  const data = await response.json().catch(() => null);
  const record = asRecord(data);
  const remote = record?.error;
  const remoteRecord = asRecord(remote);
  if (typeof remoteRecord?.message === 'string') return remoteRecord.message;
  if (typeof remote === 'string') return remote;
  if (typeof record?.message === 'string') return record.message;
  return `${fallback} (HTTP ${response.status})`;
}
